import React, {useMemo, useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import { Alert, Row, Col, Card, CardBody, Container, Input, Label } from "reactstrap";
import { withForm } from "components/common";
import { FormGroup, SaveButton, required } from "components/common";
import { compose, withState, withStateHandlers } from "recompose";
import { LocalForm, Control, actions, Errors } from "react-redux-form";
import { isEmail } from "validator";
import { Trans, withTranslation, useTranslation } from "react-i18next";
import countryList from 'react-select-country-list';
import Select from "react-select";
import { ApiClient, } from "services";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { NotificationManager } from "react-notifications";
import { useOrganisationContext } from "hooks";
import LoadingMsg from "components/common/LoadingMsg";
import { priceForRemainingDays } from "../../Helpers"
import { formatDateName } from "services/util";
import BillingContactForm, { hasBillingAddressData } from "components/BillingContact/BillingContactForm";

const HelpText = ({ children }) => (
  <span className="form-text small text-danger">
    <Trans>{children}</Trans>
  </span>
);

const useSelection = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleToggle = (feature) => {
    if (selectedItems.some(item => item.object_id === feature.object_id)) {
      setSelectedItems(selectedItems.filter(item => item.object_id !== feature.object_id));
    } else {
      setSelectedItems([...selectedItems, feature]);
    }
  };

  return [selectedItems, handleToggle];
};


export const FeatureSubscription = ({
  item,
  form,
  setDispatch,
  onSubmit,
  onUpdate,
  onChange,
  dispatch,
  success,
  failure,
  match,
  t
}) => {

  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [redirecting, setRedirecting] = useState();
  const [priceValue, setPriceValue] = useState();
  const [currency, setCurrency] = useState('SAR');
  const [subscriptionData, setSubscription] = useState();
  const [currentSubscriptionData, setCurrentSubscriptionData] = useState({});

  const [promoCode, setPromoCode] = useState();
  const [promoCodeData, setPromoCodeData] = useState(null)

  const { selectedOrganisation } = useOrganisationContext();  

  const history = useHistory()
  const client = ApiClient()

  const connectedOrg = selectedOrganisation ? selectedOrganisation?.id : 0

  const [moduleData, setModuleData] = useState();
  const [applicationData, setApplicationData] = useState();
  const [languageData, setlanguageData] = useState();
  const subscriptionID = match.params.id

  const [selectedLang, handleLanguageToggle] = useSelection();
  const [selectedMod, handleModToggle] = useSelection();
  const [selectedApp, handleAppToggle] = useSelection();

  const searchParams = new URLSearchParams(search)
  const fromPage = searchParams.get('from')
  const planType = searchParams.get('plan_type') || 'Lifetime'

  const [billingData, setBillingData] = useState({})
  const [addNewContact, setAddNewContact] = useState(true)
  const [billingAddressId, setBillingAddressId] = useState(null)

  const countryOptions = useMemo(() => countryList().getData(), [])

  const styleCheck = {
    style: { fontSize: "1rem" },
    className: "ml-2"
  }

  const checkboxStyle = {
    style: { position: 'relative', marginTop: 0, marginInlineStart: 0, }
  }

  useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true)
  //       const responseL = await client.get("core/hesaab_language");
  //       const ldata = responseL.data;
  //       setlanguageData(ldata);
  //       setLoading(false)
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       setLoading(false)
  //     }
  //   };

  //   fetchData();

  //   const fetchApplicationData = async () => {
  //     try {
  //       setLoading(true)
  //       const responseApp = await client.get("core/hesaab_application")
  //       setApplicationData(responseApp.data)
  //       setLoading(false)
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       setLoading(false)
  //     }
  //   };

  //   fetchApplicationData()

    const fetchModuleData = async () => { 
      let params = {}
      if (fromPage) {
        params['code'] = fromPage
      }

      if (planType) {
        params['plan_type'] = planType
      }

      try {
        setLoading(true)
        const responseApp = await client.get("core/hesaab_module", { params })
        setModuleData(responseApp.data)
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      }
    };

    fetchModuleData()

    const fetchSubscriptionData = async () => {
      if (connectedOrg !== 0) {
        try {
          const res = await client.get(`connected_organisations/${connectedOrg}/subscription`, { params: { plan_type: planType } });
          const data = res.data;
          setCurrentSubscriptionData(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }  

    fetchSubscriptionData();

    const fetchBillingAddressData = async () => {
      if (connectedOrg !== 0) {
        try {
          const res = await client.get(`connected_organisations/${connectedOrg}/billing-address`);
          const data = res.data;
          setBillingData(data);
          setAddNewContact(!data?.default_address)
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }  

    fetchBillingAddressData()
  }, [selectedOrganisation]);

  let currentPlan = currentSubscriptionData?.current_plan

  let showPrice = 0

  function snakeToTitle(str) {
    return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  const responseError = "No Response from the server, please try again"

  const handlePost = async (values) => {
    let selectedFeatures = [...selectedApp, ...selectedLang, ...selectedMod].map(feature => ({
      object_id: feature.id,
      content_type: feature.content_type,
    }))

    let postData = {
      connected_organisation: connectedOrg,
      plan_type: planType,
      features: selectedFeatures,
    }

    if (!addNewContact && !billingAddressId) {
      NotificationManager.error(t('Select billing contact.'))
      return
    }

    const billingValidation = hasBillingAddressData(values.billing_address_data);
    if (!billingAddressId && !billingValidation.isValid) {
      NotificationManager.error(billingValidation.error || t('Select billing contact or enter all billing contact data.'))
      return
    }

    if (billingAddressId) {
      postData['billing_address'] = billingAddressId
    } else if (billingValidation.isValid) {
      postData['billing_address_data'] = values.billing_address_data
    }

    let endpoint = `/feature-subscription`

    client.post(endpoint, postData)
      .then(response => {
          NotificationManager.success(t('Details Confirmed, You will be re-directed to payment!'));
          setIsSending(false);
          setTimeout(() => {
            setRedirecting(true)
            if (response.data.id) {
            client.post(`/payment`, {invoice: response?.data?.id})
              .then(res => {
              NotificationManager.success(t('Payment details sent to TAP!'));
              setTimeout(() => {
                if (res?.data.transaction_url) {
                  window.location.href = res?.data.transaction_url;
                } else {
                  NotificationManager.error(t(responseError))
                  setRedirecting(false)
                  return
                }
              }, 500);
            })} else {
              NotificationManager.error(t(responseError))
              setRedirecting(false)
              return
            }
          }, 500);
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const fieldName = snakeToTitle(key);
            const errorMessage = `${fieldName} - ${value}`;
            if (errorMessage === "Connected Organisation - Invalid pk \"0\" - object does not exist.") {
              NotificationManager.error(t("Your connected organisation cannot be determined"))
            } else {
            NotificationManager.error(errorMessage)
          }
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
  };

  const showTotalPrice = (subTotal, vatAmount = 0, discountedAmount = 0) => {
    return (subTotal + vatAmount - (discountedAmount || 0)).toFixed(2)
  }

  const colStyle = {
    xs: false,
    md: 6,
    className: "pt-1 pb-1"
  }

  let purchasedLanguages = currentPlan?.subscribed_feature_list?.filter(item => item.content_type_name === 'hesaablanguage').map(item => item.object_id)

  let purchasedApplications = currentPlan?.subscribed_feature_list?.filter(item => item.content_type_name === 'hesaabapplication').map(item => item.object_id)

  let purchasedModules = currentPlan?.subscribed_feature_list?.filter(item => item.content_type_name === 'hesaabmodule').map(item => item.object_id)

  const onChangeFeature = (feature, currentPlan, contentType) => {
    if (contentType === 'hesaablanguage') {
      handleLanguageToggle(feature)
    } else if (contentType === 'hesaabapplication') {
      handleAppToggle(feature)
    } else if (contentType === 'hesaabmodule') {
      handleModToggle(feature)
    }
  }

  useEffect(() => {
    let priceValue = calculateTotalPrice([...selectedLang, ...selectedApp, ...selectedMod], planType).toFixed(2)
    setPriceValue(priceValue)
  }, [selectedLang, selectedApp, selectedMod, planType])

  const calculateTotalPrice = (selectedFeatures, planType) => {
    let totalPrice = 0

    if (!selectedFeatures) return totalPrice

    for (let feature of selectedFeatures) {
      if (planType === 'Yearly') {
        totalPrice += parseFloat(feature?.yearly_price?.price || 0)
      } else if (planType === 'Monthly') {
        totalPrice += parseFloat(feature?.monthly_price?.price || 0)
      } else if (planType === 'Lifetime') {
        totalPrice += parseFloat(feature?.lifetime_price?.price || 0)
      }
    }

    return totalPrice
  }
  
  const getPrice = (item, planType) => {
    let priceInfo = null

    if (planType === 'Yearly') {
      priceInfo = item.yearly_price
    } else if (planType === 'Monthly') {
      priceInfo = item.monthly_price
    } else if (planType === 'Lifetime') {
      priceInfo = item.lifetime_price
    }
    

    if (!priceInfo) return '-'

    return `${priceInfo?.currency} ${priceInfo?.price}`
  }

  showPrice = priceValue

  return (
  <div className='payment-summary'>
    <Container>
      <Row>
        <Col xs={false}>
          <Card>
            <CardBody>
                {redirecting ? <LoadingMsg message="Redirecting"/> :
                 <LocalForm
                    initialState={item}
                    onSubmit={values => handlePost(values)}
                    getDispatch={setDispatch}
                    onUpdate={onUpdate}
                    onChange={onChange}
                  >

                <div className="row">
                  <div className="col-md-7 col-lg-8">
                    <h4 className="mb-3">{ t(`Buy ${planType} Subscription`) }</h4>
                     
                    <Row>
                        <Col md="12" xs={false}>
                            <table className="table table-sm border" style={{maxWidth:"100%"}}>
                            <thead>
                              <tr>
                                  <th className="text-left"><Trans>Name</Trans></th>
                                  <th className="text-center"><Trans>{planType} Price</Trans></th>
                                  <th className="text-right"><Trans>Select</Trans></th>
                              </tr>
                            </thead>
                            <tbody>
                            {moduleData?.map((i) => (
                                <tr key={i.id}>
                                    <td className="text-left">{i.name}</td>
                                    <td className="text-center">
                                      { 
                                        getPrice(i, planType)
                                      }
                                    </td>
                                    <td className="text-right">
                                      <Control.checkbox 
                                        model={`.mod-${i.id}`}
                                        checked={selectedMod.includes(i.id)}
                                        onChange={() => onChangeFeature(i, currentPlan, 'hesaabmodule')}
                                        disabled={!!purchasedModules?.includes(i.id)}
                                      />
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </Col>
                    </Row>

                    <BillingContactForm
                      addNewContact={addNewContact}
                      setAddNewContact={setAddNewContact}
                      billingData={billingData}
                      setBillingData={setBillingData}
                      setBillingAddressId={setBillingAddressId}
                      billingAddressId={billingAddressId}
                      countryOptions={countryOptions}
                      t={t}
                      colStyle={colStyle}
                      checkboxStyle={checkboxStyle}
                      styleCheck={styleCheck}
                    />
                  </div>

                  <div className="col-md-5 col-lg-4">
                    <h4 className="d-flex justify-content-between align-items-center mb-3">
                      <span><Trans>Price summary</Trans></span>
                    </h4>
                    
                    <ul className="list-group mb-3">
                      <li className="list-group-item d-flex justify-content-between lh-sm">
                        <div>
                          <h6 className="my-0"><Trans>Price</Trans></h6>
                          <small className="text-muted"><Trans>Selected features price</Trans></small>
                        </div>
                        <strong>{currency} {showPrice || "0.00"}</strong>
                      </li>

                      <li className="list-group-item d-flex justify-content-between">
                        <span><Trans>Sub-total ({ currency })</Trans></span>
                        <strong>{showPrice || "0.00"}</strong>
                      </li>
                      
                      <li className="list-group-item d-flex justify-content-between">
                        <span><Trans>Total ({ currency })</Trans></span>
                        <strong>{ showTotalPrice(showPrice, 0, promoCodeData?.discounted_price) }</strong>
                      </li>
                    </ul>

                    <FormGroup className="mt-4">
                      <SaveButton
                        type="submit"
                        className="btn-primary-filled btn-rounded btn-form-submit btn-rounded"
                        form={form}
                      >
                        <Trans>Continue to Payment</Trans>
                      </SaveButton>
                    </FormGroup>
                  </div>

                  </div>
                  </LocalForm>}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </div>

)
};

const enhance = compose(
  withTranslation(),
  withState("success", "setSuccess", null),
  withState("failure", "setFailure", null),
  withStateHandlers(
    {},
    {
      setFirstNameRef: () => (firstNameRef) => ({ firstNameRef }),
    }
  )
);

export default enhance(FeatureSubscription);
